import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "farmer-info flex-1 mr-5" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("p", { class: "title" }, "Your Staking Account", -1)
const _hoisted_3 = { class: "mb-2" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("p", null, "State:", -1)
const _hoisted_5 = { class: "white-box" }
const _hoisted_6 = { class: "mb-2" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("p", null, "Your identity: ", -1)
const _hoisted_8 = { class: "white-box" }
const _hoisted_9 = { class: "mb-2" }
const _hoisted_10 = /*#__PURE__*/_createElementVNode("p", null, "Associated vault: ", -1)
const _hoisted_11 = { class: "white-box" }
const _hoisted_12 = { class: "mb-2" }
const _hoisted_13 = /*#__PURE__*/_createElementVNode("p", null, "Angels Staked: ", -1)
const _hoisted_14 = { class: "white-box" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("p", null, "Mininum Period Ends " + _toDisplayString(_ctx.farmerAcc.minStakingEndsTs), 1),
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      _hoisted_4,
      _createElementVNode("p", _hoisted_5, _toDisplayString(_ctx.parseFarmerState(_ctx.farmerAcc)), 1)
    ]),
    _createElementVNode("div", _hoisted_6, [
      _hoisted_7,
      _createElementVNode("p", _hoisted_8, _toDisplayString(_ctx.farmerAcc.identity.toBase58()), 1)
    ]),
    _createElementVNode("div", _hoisted_9, [
      _hoisted_10,
      _createElementVNode("p", _hoisted_11, _toDisplayString(_ctx.farmerAcc.vault.toBase58()), 1)
    ]),
    _createElementVNode("div", _hoisted_12, [
      _hoisted_13,
      _createElementVNode("p", _hoisted_14, _toDisplayString(_ctx.farmerAcc.gemsStaked), 1)
    ]),
    _createElementVNode("button", {
      class: "button blue-button",
      onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.refreshFarmer && _ctx.refreshFarmer(...args)))
    }, " Refresh account ")
  ]))
}